<template>
  <div>
    <div class="module_addi">
      <el-select @change="getSurveyList01()" v-model="year" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <div class="btn_outer">
        <el-button type="primary" plain @click="getSurveyMonth()"><i class="cloudicon ci_modify"></i> 数据填报
        </el-button>
      </div>
    </div>
    <div class="user_module">
      <div class="module_tab">
        <span class="tab_span" v-for="(item,index) in mtab" :class="{active:index==cur}"
              @click="tabChange(index)">{{ item }}</span>
      </div>
      <div class="module_tab_cont forecast" v-show="cur==0">
        <el-table :data="tablelist" stripe :cell-class-name="ccn" @cell-click="view" style="width: 100%">
          <el-table-column prop="month" label="月份" width="200px"></el-table-column>
          <el-table-column prop="statusName" label="数据填报情况" width="260px"></el-table-column>
          <el-table-column prop="tb_time" label="提交时间" width="200px"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
				        <template slot-scope="scope">
				          <div class="btn_outer"><el-button @click="modify(scope.row.id)" type="primary" plain size="small"><i class="cloudicon ci_modify"></i>编辑</el-button>
				          	<!--<el-button @click="view(scope.row.id)" type="primary" plain size="small"><i class="cloudicon ci_property"></i>查看</el-button>-->
				          </div>
				        </template>
				  </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :current-page="currentPage"
          :page-size="pagesize"
          :total="total"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
      <div class="module_tab_cont module_tab_cont2 summary" v-show="cur==1">
        <el-table :data="tablelist2" stripe  style="width: 100%">
          <el-table-column prop="month" label="月份" width="100px"></el-table-column>
          <el-table-column prop="yc_pro" label="产值（万元）" width="500px"></el-table-column>
          <el-table-column prop="yc_gdzc" label="固定资产（万元）" width="260px"></el-table-column>

        </el-table>
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :current-page="currentPage2"
          :page-size="pagesize2"
          :total="total2"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="940px">

		  <addsurvey @emitClose="close"  v-if="dialogVisible"></addsurvey>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogVisibleEdit"
      @close="close2"
      width="940px">
		  <editsurvey @emitEditClose="close2" v-if="dialogVisibleEdit" :editId="editId" :mode="mode" ></editsurvey>
    </el-dialog>

  </div>
</template>

<script>
export default {
  created() {
    this.getSurveyList01();
  },
  name: 'usersurvey',
  inject:['reload'],
  data() {
    return {
      mtab: ['产出预测', '产出预测数据汇总'],
      cur: 0,
      currentPage: 1,
      pagesize: 10,
      currentPage2: 1,
      pagesize2: 10,
      dialogVisible: false,
      dialogVisibleEdit:false,
      tablelist: [

      ],
      total:0,
      tablelist2: [

      ],
      total2:0,
      options: [{
        value: '2021',
        label: '2021'
      }, {
        value: '2020',
        label: '2020'
      }, {
        value: '2019',
        label: '2019'
      }, {
        value: '2018',
        label: '2018'
      }],
      year: '2020',
      editId:'',
      mode:''
    }
  },
  methods: {

    tabChange(index) {
      this.cur = index;
      this.getSurveyList01();
    },
    ccn(row) {
      if (row.row.statusName.indexOf('填写')>-1 && row.columnIndex == 1) {
        return 'statwrite'
      } else if (row.row.statusName.indexOf('提交')>-1 && row.columnIndex == 1) {
        return 'statsubmit'
      }
    },
    close(){
    	this.dialogVisible = false;
    	this.reload()
    },
    modify(id){
    	this.editId = id;
    	this.dialogVisibleEdit = true;
      this.mode='edit';
    },

    view(row,column){
    	if(column.label!='操作'){
    		this.editId = row.id;
        this.dialogVisibleEdit = true;
        this.mode='view';
    	}
    },

    close2(){
    	this.dialogVisibleEdit = false;
    	this.reload()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
    handleCurrentChange2(currentPage) {
      this.currentPage2 = currentPage;
    },
    async getSurveyList01() {

      this.options=[];
      var curryear=new Date().getFullYear();
      this.year=curryear;
      for (var i=curryear;i>=2018;i--){
        var option={
          value: ''+i,
          label: ''+i
        }
        this.options.push(option)
      }

      this.tablelist=[];
      this.tablelist2=[];
      this.total=0;
      this.total2=0;
      let api='';
      if(this.cur===0){
        api='api/portal/data/indexYc?year=';
      }else if(this.cur===1){
        api='api/portal/data/indexHz?year=';
      }

      let res = await this.$ajax.get(this.bUrl + api +this.year);
      if(res.data.code!==200){
        this.$message.error(res.data.msg);
      }else {
        if(this.cur===0){
          this.tablelist = res.data.data.list;
          this.tablelist.forEach(item=>{
            if(item.status===1)
              item.statusName=' 暂存';
            else if(item.status===2){
              item.statusName='提交';
            }else {
              item.statusName='';
            }
          });
          this.total = res.data.data.total;
        }else if(this.cur===1){
          this.tablelist2 = res.data.data.list;
          this.total2 = res.data.data.total;
        }
      }
    },
    async getSurveyMonth(){
      let res = await this.$ajax.get(this.bUrl + 'api/portal/data/getId');
      if(res.data.data.year!=null && res.data.data.month!=null){
        this.dialogVisible=true;
      }else{
        this.$message.error("每月1-13日可进行数据填报，当前不在填报期");
       // this.dialogVisible=true;
      }
    }

  }
}
</script>

<style scoped>
.user_module {
  width: 100%;
  box-sizing: border-box;
  padding: 25px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 16px rgba(196, 196, 196, .16);
  border: 1px solid #E1EAFA;
  margin-bottom: 20px;
}

.tab_span {
  padding-bottom: 10px;
  font-size: 18px;
  margin-right: 54px;
  color: #6F88AF;
  cursor: pointer;
  border-bottom: 3px solid transparent;
}

.tab_span.active {
  color: #3A9FFF;
  border-bottom: 3px solid #3A9FFF;
}

.module_tab_cont {
  margin-top: 25px;
}

.module_addi {
  width: 100%;
  margin: 10px 0 30px 0;
  display: flex;
  justify-content: space-between;
}

.ci_modify {
  font-size: 24px;
}
.ci_property{
	font-size: 20px;
}
.mg1 {
  margin-bottom: 10px;
}

.mg2 {
  margin-top: 10px;
  line-height: 28px;
}

.dialog_head {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.dialog_head .tit {
  font-size: 16px;
  font-weight: bold;
  margin-right: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/usersurvey.vue